const convertDotNotationToKeys = (key: string, object: Object) => {
  const keys = key.split('.')
  return keys.reduce((object: any, key: any) => {
    return object && object[key]
  }, object)
}

export { convertDotNotationToKeys }
